import { coverageSetupVisualizationSelector } from "./coverageSetupVisualizationSelector";
import { RootState } from "../../../../../store";

export const coverageSetupVisualizationCoveredSelector = (state: RootState) => {
  return !!coverageSetupVisualizationSelector(state)?.covered;
};
